import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/components/ui/select';
import { UsersIcon } from 'lucide-react';

export interface GenderFilterProps {
  gender?: string;
  onChange: (gender: string) => void;
  placeholder: string;
  className?: string;
  disabled: boolean;
}

export function GenderFilter({
  gender,
  onChange,
  placeholder = 'Todos los géneros',
  className,
  disabled,
}: GenderFilterProps) {

  return (
    <div className={`relative ${className}`} >
      <UsersIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none z-10" />

      <Select
        value={gender || 'all'}
        onValueChange={onChange}
        disabled={disabled}
      >
        <SelectTrigger className='pl-10'>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los géneros</SelectItem>
          <SelectItem value="male">Masculino</SelectItem>
          <SelectItem value="female">Femenino</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
